import React from 'react';
import { motion } from 'framer-motion';
import './Contact.css'
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faMailBulk, faMessage, faPaperPlane, faPeopleArrows, faPhone, faSeedling, faSquare, faWineBottle } from '@fortawesome/free-solid-svg-icons';
import { SocialIcon } from 'react-social-icons';
import { MdEmail } from "react-icons/md";
import { BsFillTelephoneFill, BsInstagram } from "react-icons/bs";
import { FaInternetExplorer } from "react-icons/fa";

const Contact = () => {
    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    const onSubmit = data => {
        console.log(data);
        reset();
    };
    return (
        <motion.section className='container-fluid py-5 contact-container'
            initial={{ width: 0 }}
            animate={{ width: "100%" }}
            exit={{ x: window.innerWidth, transition: { duration: 0.3 } }}
        >
            <div className='container py-1'>
                <div className='row contact-heading'>
                    <h1 className=''>GET <span className='text-color'>IN TOUCH</span></h1>
                    <p> <span>&#9866;</span> I’M ALWAYS OPEN TO DISCUSSING PRODUCT DESIGN WORK OR PARTNERSHIPS <span>&#9866;</span> </p>
                </div>
                <div className='row'>
                    <div className='col-md-4 text-white'>
                        <div className='row'>
                            <div>
                                <h6>Phone</h6>
                                <p><span><BsFillTelephoneFill className='text-color me-2 fs-5'/></span>+880 1779 13 43 83</p>
                            </div>
                            <div>
                                <h6>Email</h6>
                                <p><span><MdEmail className='text-color me-2 fs-5'/></span>nasimitjesbd@gmail.com</p>
                            </div>
                            <div>
                                <h6>Instagram</h6>
                                <p><span><BsInstagram className='text-color me-2 fs-5'/></span>nasim/589</p>
                            </div>
                            <div>
                                <h6>Website</h6>
                                <p><span><FaInternetExplorer className='text-color me-2 fs-5'/></span>nasimreza.com</p>
                            </div>
                            <div>
                                <h6>Social Profile</h6>
                                <div className='col-md-6 d-flex align-items-center justify-content-center ms-4'>
                                    <div className=''><SocialIcon url="https://www.facebook.com/" target='_blank' /></div>
                                    <div className='px-2'><SocialIcon url="https://www.youtube.com/" /></div>
                                    <div className=''><SocialIcon url="https://www.linkedin.com/" /></div>
                                    <div className='ps-2'><SocialIcon url="https://twitter.com/" /></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-8'>
                        <p className='text-white'>If you have any suggestion, project or even you want to say Hello.. please fill out the form below and I will reply you shortly.</p>
                        <form onSubmit={handleSubmit(onSubmit)} >
                            {/* register your input into the hook by invoking the "register" function */}
                            <div className='row'>
                                <div className='col wrapper'>
                                    <FontAwesomeIcon className='icon' icon={faPeopleArrows} />
                                    <input type='text' {...register('name')} class="form-control rounded-pill p-2" placeholder="YOUR NAME" />
                                </div>
                                <div className='col wrapper'>
                                    <FontAwesomeIcon className='icon' icon={faMailBulk} />
                                    <input type='email' {...register('email')} class="form-control rounded-pill  p-2" placeholder="EMAIL" />
                                </div>
                            </div>
                            <div className='row my-3'>
                                <div className='col wrapper'>
                                    <FontAwesomeIcon className='icon' icon={faMessage} />
                                    <textarea type='text' {...register('message')} class="form-control rounded-3  p-2" rows={4} placeholder="MESSAGE" />
                                </div>
                            </div>
                            <div className='col wrapper'>
                                <FontAwesomeIcon className='icon' icon={faPaperPlane} />
                                
                                
                                <input type="submit" className='btn special-btn px-4' value='SEND MESSAGE' />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </motion.section>
    );
};

export default Contact;